import { create } from 'zustand';

export interface ConfirmRequest {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
}

interface ConfirmState {
  open: (ConfirmRequest & { resolve: (ok: boolean) => void }) | null;
}

export const useConfirm = create<ConfirmState>(() => ({ open: null }));

/**
 * Asks a yes/no question in the app's own dialog and resolves with the answer.
 * One dialog host (ConfirmHost in the shell) serves the whole app, so code
 * that is not a component — navigation, sign-out — can ask too.
 */
export function confirmAction(request: ConfirmRequest): Promise<boolean> {
  return new Promise((resolve) => {
    // A second question while one is open answers the first with "no".
    useConfirm.getState().open?.resolve(false);
    useConfirm.setState({
      open: {
        ...request,
        resolve: (ok) => {
          useConfirm.setState({ open: null });
          resolve(ok);
        },
      },
    });
  });
}

/** The question every "leave this form" path asks. */
export function confirmDiscard(): Promise<boolean> {
  return confirmAction({
    title: 'Leave without saving?',
    message: 'You have typed something that is not saved yet. If you leave now, it will be lost.',
    confirmLabel: 'Leave without saving',
    cancelLabel: 'Stay here',
    danger: true,
  });
}
